// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hf-toast-container {
    position: fixed;
    right: 18px;
    bottom: 18px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    z-index: 2147483647;
    /* πάντα από πάνω */
}

.hf-toast {
    min-width: 180px;
    max-width: 420px;
    padding: 10px 14px;
    border-radius: 12px;
    box-shadow: 0 8px 26px rgba(0, 0, 0, .18);
    color: #fff;
    font-size: 14px;
    line-height: 1.2;
    display: inline-flex;
    align-items: center;
    -webkit-backdrop-filter: blur(4px);
            backdrop-filter: blur(4px);
    transition: transform .15s ease, opacity .15s ease;
    opacity: .98;
}

.hf-toast.success {
    background: #19a974;
}

/* πράσινο */
.hf-toast.error {
    background: #e03131;
}

/* κόκκινο */
.hf-toast.info {
    background: #3b82f6;
}

/* μπλε  */`, "",{"version":3,"sources":["webpack://./src/views/industry/advertisements/Toast/toast.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,kCAA0B;YAA1B,0BAA0B;IAC1B,kDAAkD;IAClD,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,mBAAmB;AACvB;;AAEA,UAAU","sourcesContent":[".hf-toast-container {\n    position: fixed;\n    right: 18px;\n    bottom: 18px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    z-index: 2147483647;\n    /* πάντα από πάνω */\n}\n\n.hf-toast {\n    min-width: 180px;\n    max-width: 420px;\n    padding: 10px 14px;\n    border-radius: 12px;\n    box-shadow: 0 8px 26px rgba(0, 0, 0, .18);\n    color: #fff;\n    font-size: 14px;\n    line-height: 1.2;\n    display: inline-flex;\n    align-items: center;\n    backdrop-filter: blur(4px);\n    transition: transform .15s ease, opacity .15s ease;\n    opacity: .98;\n}\n\n.hf-toast.success {\n    background: #19a974;\n}\n\n/* πράσινο */\n.hf-toast.error {\n    background: #e03131;\n}\n\n/* κόκκινο */\n.hf-toast.info {\n    background: #3b82f6;\n}\n\n/* μπλε  */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
